import React from "react";
import Surface from "../../theme/Surface";

/**
 * FeedLockedCard — shown in place of the composer while the typing gate is
 * unmet. The feed is the payoff for finishing the typing curriculum; this
 * card is the bridge: progress bar + a CTA straight into the tutor.
 *
 * Props:
 *   typingGate  — { completed_count, required_count, percent, next_lesson_title, required_lesson_title }
 *   onOpenTyping — () => void (opens TypingView)
 */
export default function FeedLockedCard({ typingGate, onOpenTyping }) {
  const gate = typingGate || {};
  return (
    <Surface className="rounded-2xl px-4 py-4">
      <div className="flex items-start gap-3">
        <span className="p-2 rounded-lg shrink-0" style={{ background: "color-mix(in srgb, var(--gold) 15%, transparent)", color: "var(--gold)" }} aria-hidden="true">
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
            <rect x="5" y="11" width="14" height="9" rx="2" strokeLinecap="round" strokeLinejoin="round" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 11V8a4 4 0 118 0v3" />
          </svg>
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium" style={{ color: "var(--parchment)" }}>
            Learn to type Arabic to start posting
          </p>
          <p className="text-xs mt-0.5" style={{ color: "var(--parchment-dim)" }}>
            Finish the typing lessons through “{gate.required_lesson_title || "the ḥarakāt"}” and the
            composer unlocks. {gate.completed_count ?? 0} of {gate.required_count ?? "…"} done
            {gate.next_lesson_title ? ` — next: ${gate.next_lesson_title}` : ""}.
          </p>
          <div className="progress-track mt-2" aria-hidden="true">
            <div className="progress-fill" style={{ width: `${gate.percent ?? 0}%` }} />
          </div>
          <button onClick={onOpenTyping} className="dt-ghost-btn text-sm px-3 py-2 rounded-xl mt-3">
            Continue typing lessons →
          </button>
        </div>
      </div>
    </Surface>
  );
}
